import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Sparkles, ArrowRight } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

export default function SanctuaryWallModal({ isOpen, onClose }) {
    const { breakFree } = useAuth();

    return (
        <AnimatePresence>
            {isOpen && (
                <div className="fixed inset-0 z-[200] flex items-center justify-center p-6">
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={onClose}
                        className="absolute inset-0 bg-black/60 backdrop-blur-md"
                    />

                    <motion.div
                        initial={{ scale: 0.9, opacity: 0, y: 20 }}
                        animate={{ scale: 1, opacity: 1, y: 0 }}
                        exit={{ scale: 0.9, opacity: 0, y: 20 }}
                        className="relative w-full max-w-md bg-white dark:bg-gray-900 rounded-[2rem] p-8 md:p-10 shadow-2xl text-center space-y-8 overflow-hidden"
                    >
                        {/* Decorative Background */}
                        <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-brand-blue via-brand-purple to-brand-blue" />
                        
                        <div className="mx-auto w-20 h-20 bg-brand-blue/10 rounded-full flex items-center justify-center text-brand-blue mb-2">
                            <Sparkles className="w-10 h-10" />
                        </div>

                        <div className="space-y-4">
                            <h2 className="text-3xl font-display font-medium text-gray-900 dark:text-white leading-tight">
                                Beyond the Realms
                            </h2>
                            <p className="text-lg text-gray-500 dark:text-gray-400 font-serif italic leading-relaxed">
                                "Hope you are enjoying the platform, O' traveller, but to go beyond the realms, please secure your space into sanctuary."
                            </p>
                        </div>

                        <div className="flex flex-col gap-4">
                            <button
                                onClick={breakFree}
                                className="group relative w-full flex items-center justify-center gap-3 px-8 py-4 bg-gray-900 dark:bg-white text-white dark:text-gray-900 rounded-full font-bold text-lg hover:scale-105 transition-all shadow-xl"
                            >
                                Yes, I want to break free
                                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                            </button>
                            
                            <button
                                onClick={onClose}
                                className="text-sm font-medium text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 transition-colors py-2"
                            >
                                Not just yet.
                            </button>
                        </div>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>
    );
}
